import { useMutationDeleteLeaveResources } from '../../resources/mutations/useMutationDeleteLeaveResources.js';
import { useResourceDataContextSafe } from '../components/context/resourceDataContext.js';
import { useQueryUserInfo } from '../../user/queries/useQueryUserInfo.js';

const useDeleteOrLeaveResource = ({ onConfirmDelete, onConfirmLeave } = {}) => {
  const { resource, disabledActions } = useResourceDataContextSafe();
  const mutationDeleteResources = useMutationDeleteLeaveResources();
  const { data: user } = useQueryUserInfo();
  if (resource.user && resource.permission?.hasAddedDirectly && resource.user.id !== user?.id) {
    return {
      label: resource.kind === "folder" ? "Leave folder" : "Leave item",
      action: async () => {
        mutationDeleteResources.confirmAndMutate({
          resourceIdsToLeave: [
            resource.id
          ]
        }, {
          onConfirm: async () => {
            return onConfirmLeave?.(resource.id);
          }
        });
      }
    };
  } else {
    return {
      label: "Delete",
      action: () => mutationDeleteResources.confirmAndMutate({
        resourceIds: [
          resource.id
        ]
      }, {
        onConfirm: async () => {
          return onConfirmDelete?.(resource.id);
        }
      }),
      disabledReason: disabledActions.remove
    };
  }
};

export { useDeleteOrLeaveResource };
//# sourceMappingURL=useDeleteOrLeaveResource.js.map
